import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"
import type { GatsbyImageProps } from "gatsby-plugin-image"

const imgQuery = graphql`
  {
    mob: file(relativePath: { eq: "redesignPkw/halvaMob.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
    desk: file(relativePath: { eq: "redesignPkw/halvaDesk.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
  }
`

export function Img(props: Omit<GatsbyImageProps, "image">) {
  const data = useStaticQuery(imgQuery)

  const images = withArtDirection(getImage(data.desk)!, [
    {
      media: "(max-width: 959.95px)",
      image: getImage(data.mob)!,
    },
  ])

  return <GatsbyImage loading="eager" {...props} image={images} />
}
